import type { UserAuthLoginData, UserAuthProfile } from '@glyphic/user-api-types'

import { apiRequest } from './client'

export type AuthLoginBody = {
  username: string
  password: string
}

/** @deprecated 使用 UserAuthLoginData */
export type AuthLoginData = UserAuthLoginData

export function loginRequest(body: AuthLoginBody) {
  return apiRequest<UserAuthLoginData>('/v1/auth/login', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getAuthMe() {
  return apiRequest<UserAuthProfile>('/v1/auth/me')
}

export function logoutRequest() {
  return apiRequest<void>('/v1/auth/logout', {
    method: 'POST',
    body: JSON.stringify({}),
  })
}
